import { useState } from "react";
import Card from "./ui/Card";
import Input from "./ui/Input";
import Btn from "./ui/Btn";

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    if (!username || !password) {
      setError("أدخل اسم المستخدم وكلمة المرور");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        setError(d.detail || "بيانات غير صحيحة");
        setLoading(false);
        return;
      }
      const data = await res.json();
      localStorage.setItem("token", data.token);
      if (data.csrf_token) localStorage.setItem("csrf_token", data.csrf_token);
      onLogin(data.user, data.stations || []);
    } catch {
      setError("خطأ في الاتصال");
    }
    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") submit();
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#020817",
        padding: 20,
      }}
    >
      <div style={{ width: "100%", maxWidth: 400 }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: 20,
              background: "linear-gradient(135deg,#38bdf8,#818cf8)",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 36,
              marginBottom: 16,
              boxShadow: "0 0 40px #38bdf855",
            }}
          >
            📷
          </div>
          <h1
            style={{
              color: "#f1f5f9",
              fontSize: 24,
              fontWeight: 800,
              margin: 0,
            }}
          >
            نظام مراجعة الكاميرات
          </h1>
          <p style={{ color: "#64748b", margin: "8px 0 0", fontSize: 14 }}>
            تسجيل الدخول للمتابعة
          </p>
        </div>
        <Card style={{ padding: 28 }}>
          <div
            style={{ display: "flex", flexDirection: "column", gap: 16 }}
            onKeyDown={handleKeyDown}
          >
            <Input
              label="اسم المستخدم"
              value={username}
              onChange={setUsername}
              required
            />
            <Input
              label="كلمة المرور"
              type="password"
              value={password}
              onChange={setPassword}
              required
            />
            {error && (
              <div
                style={{
                  background: "#1c0303",
                  border: "1px solid #ef444444",
                  borderRadius: 8,
                  padding: "10px 14px",
                  color: "#ef4444",
                  fontSize: 13,
                }}
              >
                ⚠️ {error}
              </div>
            )}
            <Btn
              onClick={submit}
              disabled={loading}
              color="#38bdf8"
              size="lg"
              style={{ width: "100%", marginTop: 4 }}
            >
              {loading ? "⏳ جاري الدخول..." : "🔐 دخول"}
            </Btn>
          </div>

        </Card>
      </div>
    </div>
  );
}
